import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { NotificationCenterMessageDto } from './models/notification-center-message-dto.model';

export interface NotificationCenterState extends EntityState<NotificationCenterMessageDto> {
  total: number;
  unseenCount: number;
  ui: {
    isOpen: boolean;
    currentPage: number;
    amountPerPage: number;
  };
}

const initialState = {
  total: 0,
  unseenCount: 0,
  ui: {
    isOpen: false,
    currentPage: 1,
    amountPerPage: 10,
  },
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'notification-center', idKey: 'id' })
export class NotificationCenterStore extends EntityStore<NotificationCenterState> {
  constructor() {
    super(initialState);
  }

  updateUI(ui: NotificationCenterState['ui']) {
    this.update((state) => ({
      ui: {
        ...state.ui,
        ...ui,
      },
    }));
  }
}
